var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.958 47.427H8.46901C3.79201 47.427 0 43.635 0 38.958V8.46901C0 3.79201 3.79201 0 8.46901 0H38.958C43.635 0 47.427 3.79201 47.427 8.46901V38.958C47.427 43.636 43.635 47.427 38.958 47.427Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4803 19.9995H12.4795V35.9999H17.4803V19.9995Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9569 17.9047C16.5902 17.9047 17.9137 16.5816 17.9137 14.9518C17.9137 13.322 16.5902 12 14.9569 12C13.3236 12 12 13.322 12 14.9518C12 16.5816 13.3225 17.9047 14.9569 17.9047Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4733 27.6008C25.4733 25.3513 26.5187 24.0111 28.5198 24.0111C30.3589 24.0111 31.2423 25.2978 31.2423 27.6008C31.2423 29.9057 31.2423 36.0001 31.2423 36.0001H36.2196C36.2196 36.0001 36.2196 30.155 36.2196 25.869C36.2196 21.5831 33.7671 19.5112 30.3416 19.5112C26.915 19.5112 25.4733 22.1553 25.4733 22.1553V19.9997H20.6763V36.0001H25.4733C25.4733 36.0001 25.4733 30.0662 25.4733 27.6008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedDark);
export default __webpack_public_path__ + "static/media/linked-dark.0f052d34b4a6e974293b01694663ba5f.svg";
export { ForwardRef as ReactComponent };